import { render } from "./FTLBid.vue?vue&type=template&id=20a8ffce&scoped=true&ts=true"
import script from "./FTLBid.vue?vue&type=script&lang=ts"
export * from "./FTLBid.vue?vue&type=script&lang=ts"

import "./FTLBid.vue?vue&type=style&index=0&id=20a8ffce&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a8ffce"]])

export default __exports__